import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface LocationUpdateDetails {
  fromCity: string;
  toCity: string;
}

@Injectable({
  providedIn: 'root'
})
export class LocationUpdateModalService {
  private readonly showSubject = new Subject<LocationUpdateDetails>();

  /** Emits when the header should open the location-updated success modal. */
  readonly show$ = this.showSubject.asObservable();

  show(fromCity: string, toCity: string): void {
    const from = (fromCity || '').trim();
    const to = (toCity || '').trim();
    if (!from || !to || from.toLowerCase() === to.toLowerCase()) {
      return;
    }
    this.showSubject.next({ fromCity: from, toCity: to });
  }
}
